import Hero from "../Home/Hero";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import { Link } from "react-router-dom";
import HomePackages from "../TourPackages/HomePackages";
import UserCustomPkg from "../UserCustomPkg/UserCustomPkg";
import Testimonial from "../Testimonial/Testimonial";

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

export default function Home() {
  return (
    <>
      <Header />
      <div>
        <Hero />
        <main id="content" className="site-main">
          {/* Home search field html start */}
          <UserCustomPkg />
          {/* search search field html end */}
          <section className="destination-section">
            <div className="container">
              <div className="section-heading">
                <div className="row align-items-end">
                  <div className="col-lg-7">
                    <h5 className="dash-style">POPULAR DESTINATION</h5>
                    <h2>TOP NOTCH DESTINATION</h2>
                  </div>
                  <div className="col-lg-5">
                    <div className="section-disc">
                      Experience our popular destination at JourneyScape.
                      Immerse yourself in top-notch destinations that captivate
                      the senses and leave you in awe.
                    </div>
                  </div>
                </div>
              </div>
              <div className="destination-inner destination-three-column">
                <div className="row">
                  <div className="col-lg-7">
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="desti-item overlay-desti-item">
                        <Link to="/Punjab">
                          <figure className="desti-image">
                            
                            <img
                              src="https://res.cloudinary.com/debltnmge/image/upload/c_fill,h_560,w_322/v1685217868/Minar_e_Pakistan_2021_1_ntn456.webp"
                              alt=""
                            />
                          </figure>
                          <div className="meta-cat bg-meta-cat">
                          <Link to="/Punjab">PUNJAB</Link>
                          </div>
                          <div className="desti-content">
                            <h3>
                            <Link to="/Punjab">Minar e Pakisan</Link>
                            </h3>
                            <div
                              className="rating-start"
                              title="Rated 5 out of 4"
                            >
                              <span style={{ width: "53%" }} />
                            </div>
                          </div>
                          </Link>
                        </div>
                      </div>
                      <div className="col-sm-6">
                      <Link to="/Sindh">
                        <div className="desti-item overlay-desti-item">
                          <figure className="desti-image">
                            <img
                              src="https://res.cloudinary.com/debltnmge/image/upload/c_fill,h_560,w_322/v1685218767/photo-1621307229540-a94299c37fc1_mhjpa8.webp"
                              alt=""
                            />
                          </figure>
                          <div className="meta-cat bg-meta-cat">
                          <Link to="/Sindh">Sindh</Link>
                          </div>
                          <div className="desti-content">
                            <h3>
                            <Link to="/Sindh">Merewether Clock Tower</Link>
                            </h3>
                            <div
                              className="rating-start"
                              title="Rated 5 out of 5"
                            >
                              <span style={{ width: "100%" }} />
                            </div>
                          </div>
                        </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div className="row">
                      <div className="col-md-6 col-xl-12">
                      <Link to="/KPK">
                        <div className="desti-item overlay-desti-item">
                          <figure className="desti-image">
                            <img
                              src="https://res.cloudinary.com/debltnmge/image/upload/c_fill,h_260,w_460/v1685219188/Cover-1_1_n8yczy.webp"
                              alt=""
                            />
                          </figure>
                          <div className="meta-cat bg-meta-cat">
                          <Link to="/KPK">KPK</Link>
                          </div>
                          <div className="desti-content">
                            <h3>
                            <Link to="/KPK">Mountains</Link>
                            </h3>
                            <div
                              className="rating-start"
                              title="Rated 5 out of 5"
                            >
                              <span style={{ width: "100%" }} />
                            </div>
                          </div>
                        </div>
                        </Link>
                      </div>
                      <div className="col-md-6 col-xl-12">
                      <Link to="/Balochistan">
                        <div className="desti-item overlay-desti-item">
                          <figure className="desti-image">
                            <img
                              src="https://res.cloudinary.com/debltnmge/image/upload/c_fill,h_255,w_460/v1685220777/photo-1608020932658-d0e19a69580b_1_pmdfqg.webp"
                              alt=""
                            />
                          </figure>
                          <div className="meta-cat bg-meta-cat">
                          <Link to="/Balochistan">BALOCHISTAN</Link>
                          </div>
                          <div className="desti-content">
                            <h3>
                            <Link to="/Balochistan">Faisal Mosque</Link>
                            </h3>
                            <div
                              className="rating-start"
                              title="Rated 5 out of 4"
                            >
                              <span style={{ width: "60%" }} />
                            </div>
                          </div>
                        </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="btn-wrap text-center">
                  <Link to="/TourPackages" className="button-primary" onClick={scrollToTop}>
                    MORE DESTINATION
                  </Link>
                </div>
              </div>
            </div>
          </section>
          <section className="home-about-section">
            <div className="container">
              <div className="row">
                <div className="col-lg-7">
                  <div className="about-img-wrap">
                    <div className="about-img-left">
                      <div className="about-content secondary-bg d-flex flex-wrap">
                        <h3>Something you want to know about us !!</h3>
                        <Link to="/About" className="button-primary">
                          LEARN MORE
                        </Link>
                      </div>
                      <div className="about-img">
                        <img
                          src="https://res.cloudinary.com/debltnmge/image/upload/c_scale,h_450,w_360/v1685298696/karan-bhatia-SxoYOcg_aQ8-unsplash_rmopuo.jpg"
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="about-img-right">
                      <div className="about-img">
                        <img
                          src="https://res.cloudinary.com/debltnmge/image/upload/c_fill,h_330,w_455/v1685220565/majyd-inam-Q0u4kDHiGEs-unsplash_1_kvtvdx.jpg"
                          alt=""
                        />
                      </div>
                      <div className="about-img">
                        <img
                          src="https://res.cloudinary.com/debltnmge/image/upload/c_fill,h_305,w_365/v1685298560/hamza-sultan-b951x6Y16BU-unsplash_gvneeh.jpg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="banner-content section-heading">
                    <h5>INTRODUCTION ABOUT US</h5>
                    <h2 className="banner-title">
                      ULTIMATE GUIDE TO EPIC ADVENTURE
                    </h2>
                    <div className="title-icon-divider">
                      <i className="fas fa-suitcase-rolling" />
                    </div>
                    <p>
                      JourneyScape is a premier travel agency specializing in
                      crafting unforgettable tourism experiences in Pakistan and
                      neighboring countries. With our expertly designed
                      packages, we aim to showcase the rich cultural heritage,
                      breathtaking landscapes, and warm hospitality of the
                      region.
                    </p>
                  </div>
                  <div className="about-service-container">
                    <div className="about-service">
                      <div className="about-service-icon">
                        <img
                          src="https://res.cloudinary.com/debltnmge/image/upload/v1685298023/icon15_a59fxr.png"
                          alt=""
                        />
                      </div>
                      <div className="about-service-content">
                        <h4>BEST PRICE GUARANTEED</h4>
                        <p>
                          At JourneyScape, we offer the Best Price Guaranteed
                          for our tourism packages.
                        </p>
                      </div>
                    </div>
                    <div className="about-service">
                      <div className="about-service-icon">
                        <img
                          src="https://res.cloudinary.com/debltnmge/image/upload/v1685298170/icon16_cnozoc.png"
                          alt=""
                        />
                      </div>
                      <div className="about-service-content">
                        <h4>AMAZING DESTINATION</h4>
                        <p>
                          Embark on a journey to amazing destinations with
                          JourneyScape.
                        </p>
                      </div>
                    </div>
                    <div className="about-service">
                      <div className="about-service-icon">
                        <img
                          src="https://res.cloudinary.com/debltnmge/image/upload/v1685298227/icon17_r6i0ux.png"
                          alt=""
                        />
                      </div>
                      <div className="about-service-content">
                        <h4>PERSONAL SERVICES</h4>
                        <p>
                          At JourneyScape, we pride ourselves on providing
                          personalized services.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Home packages section html start */}
          <section className="package-section">
            <div className="container">
              <div className="section-heading text-center">
                <div className="row">
                  <div className="col-lg-8 offset-lg-2">
                    <h5 className="dash-style">EXPLORE GREAT PLACES</h5>
                    <h2>POPULAR PACKAGES</h2>
                    <p>
                      Discover our popular packages at JourneyScape. Experience
                      the allure of breathtaking destinations, indulge in unique
                      adventures, and create unforgettable memories.
                    </p>
                  </div>
                </div>
              </div>
              <div className="package-inner">
                <HomePackages />
                <div className="btn-wrap text-center">
                  <Link to="/TourPackages" className="button-primary" onClick={scrollToTop}>
                    VIEW ALL PACKAGES
                  </Link>
                </div>
              </div>
            </div>
          </section>
          {/* packages html end */}
          <section
            className="activity-section activity-bg-image"
            style={{
              backgroundImage:
                "url(https://res.cloudinary.com/debltnmge/image/upload/c_fill,h_700,w_1200/v1685431728/sabeer-darr-smcJiDeZu34-unsplash_n0bmx1.jpg)",
            }}
          >
            <div className="container">
              <div className="section-heading section-heading-white text-center">
                <div className="row">
                  <div className="col-lg-8 offset-lg-2">
                    <h5>EXPLORE GREAT PLACES</h5>
                    <h2>POPULAR PACKAGES</h2>
                    <div className="title-icon-divider">
                      <i className="fas fa-suitcase-rolling" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="activity-inner row">
                <div className="col-lg-2 col-md-4 col-6">
                  <div className="activity-item">
                    <div className="activity-icon">
                      <a href="/">
                        <img
                          src="https://res.cloudinary.com/debltnmge/image/upload/v1685430556/img44_qhzif2.png"
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="activity-content">
                      <h4>
                        <a href="/">Adventure</a>
                      </h4>
                      <p>15 Destination</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-4 col-6">
                  <div className="activity-item">
                    <div className="activity-icon">
                      <a href="/">
                        <img
                          src="https://res.cloudinary.com/debltnmge/image/upload/v1685430624/img45_qdhtgg.png"
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="activity-content">
                      <h4>
                        <a href="/">Trekking</a>
                      </h4>
                      <p>12 Destination</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-4 col-6">
                  <div className="activity-item">
                    <div className="activity-icon">
                      <a href="/">
                        <img
                          src="https://res.cloudinary.com/debltnmge/image/upload/v1685430977/img46_x0fpad.png"
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="activity-content">
                      <h4>
                        <a href="/">Camp Fire</a>
                      </h4>
                      <p>7 Destination</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-4 col-6">
                  <div className="activity-item">
                    <div className="activity-icon">
                      <a href="/">
                        <img
                          src="https://res.cloudinary.com/debltnmge/image/upload/v1685431067/img47_stsukc.png"
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="activity-content">
                      <h4>
                        <a href="/">Off Road</a>
                      </h4>
                      <p>15 Destination</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-4 col-6">
                  <div className="activity-item">
                    <div className="activity-icon">
                      <a href="/">
                        <img
                          src="https://res.cloudinary.com/debltnmge/image/upload/v1685431125/img48_qfljyr.png"
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="activity-content">
                      <h4>
                        <a href="/">Camping</a>
                      </h4>
                      <p>13 Destination</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-4 col-6">
                  <div className="activity-item">
                    <div className="activity-icon">
                      <a href="/">
                        <img
                          src="https://res.cloudinary.com/debltnmge/image/upload/v1685431182/img49_t90vt0.png"
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="activity-content">
                      <h4>
                        <a href="/">Exploring</a>
                      </h4>
                      <p>25 Destination</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <Testimonial />
          <section
            className="subscribe-section subscribe-bg-image"
            style={{
              backgroundImage:
                "url(https://res.cloudinary.com/debltnmge/image/upload/v1685435035/img16_ze7e0v.jpg)",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-7">
                  <div className="section-heading section-heading-white pr-40">
                    <h5>TRAVEL OFFER &amp; DISCOUNT</h5>
                    <h2>HOLIDAY SPECIAL 25% OFF !</h2>
                    <div className="title-icon-divider">
                      <i className="fas fa-suitcase-rolling" />
                    </div>
                    
                    <p>
                      Our agency has been proudly recognized as the best in the
                      market. With years of experience and a strong commitment
                      to excellence, we have established ourselves as a trusted
                      name in the travel industry.
                    </p>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="progress-wrap">
                    <div className="progress-inner">
                      <div className="progress-circle" data-percentage={80}>
                        <span className="circle-left">
                          <span className="circle-bar" />
                        </span>
                        <span className="circle-right">
                          <span className="circle-bar" />
                        </span>
                        <div className="progress-value">85%</div>
                      </div>
                      <h4>Satisfied clients</h4>
                    </div>
                    <div className="progress-inner">
                      <div className="progress-circle" data-percentage={70}>
                        <span className="circle-left">
                          <span className="circle-bar" />
                        </span>
                        <span className="circle-right">
                          <span className="circle-bar" />
                        </span>
                        <div className="progress-value">75%</div>
                      </div>
                      <h4>Reasonable price</h4>
                    </div>
                    <div className="progress-inner">
                      <div className="progress-circle" data-percentage={70}>
                        <span className="circle-left">
                          <span className="circle-bar" />
                        </span>
                        <span className="circle-right">
                          <span className="circle-bar" />
                        </span>
                        <div className="progress-value">70%</div>
                      </div>
                      <h4>Best destination</h4>
                    </div>
                    <div className="progress-inner">
                      <div className="progress-circle" data-percentage={90}>
                        <span className="circle-left">
                          <span className="circle-bar" />
                        </span>
                        <span className="circle-right">
                          <span className="circle-bar" />
                        </span>
                        <div className="progress-value">90%</div>
                      </div>
                      <h4>Positive reviews</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
      <Footer />
    </>
  );
}
